import React from 'react';
import styles from "../../../Styles/ComponentStyles/MainPages/dashboard.module.scss"
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// ✅ Register necessary chart elements
ChartJS.register(
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
    Filler
);

interface FeeImpactChartProps {
    data: any[];
    companyName: string; //
}

const FeeImpactChart = (props: any) => {

    const { data, companyName } = props

    const chartData = {
        labels: data.map((d: any) => `${d.year}`),
        datasets: [
            {
                label: 'Acrylic',
                data: data.map((d: any) => parseFloat(d.yearEndingBalance.acrylic)),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                tension: 0.3,
                fill: false
            },
            {
                label: companyName || 'Other Company',
                data: data.map((d: any) => parseFloat(d.yearEndingBalance.otherCompany)),
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.3,
                fill: false
            }
        ]
    };

    const options = {
        responsive: true, // ✅ enable responsiveness
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                mode: 'index' as const,
                intersect: false
            },
            legend: {
                display: true,
                position: 'top' as const
            }
        },
        scales: {
            x: {
                type: 'category' as const,
                title: {
                    display: true,
                    text: 'Years'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Portfolio Balance ($)'
                },
                ticks: {
                    callback: (value: any) => `$${value.toLocaleString()}`
                }
            }
        }
    };

    const whiteBackgroundPlugin = {
        id: 'whiteBackground',
        beforeDraw: (chart: any) => {
            const ctx = chart.canvas.getContext('2d');
            ctx.save();
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
        }
    };

    return (
        <>
            <div className={styles.chartWrapper}>
                <Line
                    data={chartData}
                    options={options}
                    plugins={[whiteBackgroundPlugin]}
                    className={styles.lineChart}
                />
            </div>

        </>
    );
};

export default FeeImpactChart;
